import { render, staticRenderFns } from "./editInformation_center.vue?vue&type=template&id=386b674c&scoped=true&"
import script from "./editInformation_center.vue?vue&type=script&lang=js&"
export * from "./editInformation_center.vue?vue&type=script&lang=js&"
import style0 from "./editInformation_center.vue?vue&type=style&index=0&id=386b674c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386b674c",
  null
  
)

export default component.exports